import styled from "styled-components"

export default styled.h4`
  font-size: 20px;
  color: #343434;
  font-weight: 400;
`
